import React from 'react';

const ArrowIcon = ({ className }) => (
  <svg
    className={className}
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.353516 7.5L7.35352 0.5M7.35352 0.5V7.5M7.35352 0.5H0.353516"
      stroke="white"
    />
  </svg>
);

export default ArrowIcon;

